const state = {
    orderDetails: null,
    // 订单中选择的商品
    choiceGoodsItem: {},
    choiceGoodsItemIndex: 0,
    // 我的订单进入时的列表状态
    choiceOrderListStatus: 0,
    deliveryArr: []
};
const actions = {};
const getters = {
    deliveryArr: (state) => state.deliveryArr
};
const mutations = {
    setDeliveryArr(state, payload) {
        let deliveryArr = [];
        payload.orderRespDTOList.forEach((item, index) => {
            let value = item.value;
            let { isPickupStr,
                isPickup,
                outletId,
                pickupShow,
                outletShow,
                outletName,
                deliveryMethodStr,
                deliveryMethodCode,
                skuCode } = value;
            deliveryArr.push({ isPickupStr,
                isPickup,
                outletId,
                outletName,
                pickupShow,
                outletShow,
                deliveryMethodStr,
                deliveryMethodCode,
                skuCode });
        });
        state.deliveryArr = deliveryArr;
    },
    setOrderDetails(state, payload) {
        state.orderDetails = payload.orderDetails;
    },
    // 改变orderDetails的数据，新增修改
    changeOrderDetails(state, payload) {
        state.orderDetails[payload.statusName] = payload.status;
    },
    changeOrderItemDetails(state, payload) {
        state.orderDetails.memberOrderItemList[payload.index][payload.statusName] = payload.status;
    },
    changeChoiceGoodsItem(state, payload) {
        state.choiceGoodsItem[payload.statusName] = payload.status;
    },
    setChoiceGoodsItem(state, payload) {
        state.choiceGoodsItem = payload.choiceGoodsItem;
    },
    setChoiceGoodsItemIndex(state, payload) {
        state.choiceGoodsItemIndex = payload.choiceGoodsItemIndex;
    },
    setChoiceOrderListStatus(state, payload) {
        state.choiceOrderListStatus = payload.choiceOrderListStatus;
    }

};
export default {
    state,
    actions,
    getters,
    mutations
};
